import { Node } from 'tiptap'
import Blank from '@/components/tiptap/extensions/Blank.vue'

export default class QuestionNode extends Node {
    get name () {
        return 'blank_node'
    }

    get schema () {
        return {
            attrs: {
                blank_id: {
                    default: null,
                },
                answer: {
                    default: null
                },
                class: {
                    default: 'blank'
                }
            },
            group: 'inline',
            inline: true,
            selectable: false,
            isolating: false,
            draggable: true,
            parseDOM: [{
                tag: 'blank',
                getAttrs: dom => ({
                    blank_id: dom.getAttribute('blank_id'),
                    answer: dom.getAttribute('answer'),
                    class: dom.getAttribute('class')
                }),
            }],
            toDOM: node => ['blank', {
                blank_id: (node.attrs && node.attrs.blank_id) ? node.attrs.blank_id : null,
                answer: (node.attrs && node.attrs.answer) ? node.attrs.answer : null,
                class: (node.attrs && node.attrs.class) ? node.attrs.class : null,
            }],
        }
    }

    commands({ type }) {
        return (attrs) => (state, dispatch) => {
            dispatch(state.tr.replaceSelectionWith(
                type.create({
                    'blank_id': (attrs) ? attrs.blank_id : null,
                    'answer': (attrs) ? attrs.answer : null,
                })
            ))
        }
    }

    get view () {
        return Blank
    }
}
